export default __webpack_public_path__ + "static/1363-c1e221aa921bffa3d468d45b08e6c41a.gif";